import SeverityToggle from '../components/SeverityToggle.vue';
import { loadSeverityFilter, saveSeverityFilter, severityKey } from '../consts/ChangeEvents.consts';

/**
 * Gives a screen the severity switches that sit above its charts.
 *
 * Every chart in Change Events uses this, so the four switches behave the same
 * everywhere and the choice follows the person from screen to screen. The
 * choice is kept in localStorage, the same place PaginationBar keeps the page
 * size.
 *
 * A screen using this mixin gets:
 *   - `visibleSeverities` — the severities that are on
 *   - `noSeveritySelected` — true when all four are off
 *   - `onSeverityChange(keys)` — bind to the toggle's `change`
 *   - `isSeverityOn(value)` — for filtering rows that carry a severity
 */
export default {
  components: { SeverityToggle },
  data() {
    return {
      visibleSeverities: loadSeverityFilter()
    };
  },
  computed: {
    /** All four off. The chart is then empty on purpose, and says so. */
    noSeveritySelected() {
      return this.visibleSeverities.length === 0;
    }
  },
  methods: {
    onSeverityChange(keys) {
      this.visibleSeverities = Array.isArray(keys) ? keys : [];
      saveSeverityFilter(this.visibleSeverities);
    },
    /**
     * True when a row of this severity should be drawn.
     * @param {*} value any severity value, in any letter case
     * @returns {boolean}
     */
    isSeverityOn(value) {
      return this.visibleSeverities.indexOf(severityKey(value)) !== -1;
    }
  }
};
